import { FilmstripView } from '@atlaskit/media-filmstrip';
import * as React from 'react';
import { useState } from 'react';
import { Image } from '../Image';
import { FilmstripItem, FilmstripWrapper } from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Resizes the media object via media service for the thumbnails to avoid pixelation. Larger screenshots
 * resized on the client side to 300x160px appear really pixelated.
 *
 * @see https://developer.atlassian.com/platform/media/advanced-topics/file-previews/#resizing
 */
export const getDynamicCropMediaURL = (dataURI, width, height) => {
  const url = new URL(dataURI);
  url.searchParams.set('width', width);
  url.searchParams.set('height', height);
  url.searchParams.set('mode', 'crop');
  return url.toString();
};
export const MediaFilmstrip = props => {
  const {
    items,
    handleMediaClick
  } = props;
  const [{
    animate,
    offset
  }, setState] = useState({
    animate: false,
    offset: 0
  });
  const handleSize = _ref => {
    let {
      offset: newOffset
    } = _ref;
    setState({
      offset: newOffset,
      animate
    });
  };
  const handleScroll = _ref2 => {
    let {
      animate: newAnimate,
      offset: newOffset
    } = _ref2;
    setState({
      animate: newAnimate,
      offset: newOffset
    });
  };
  return /*#__PURE__*/_jsx(FilmstripWrapper, {
    children: /*#__PURE__*/_jsx(FilmstripView, {
      offset: offset,
      animate: animate,
      onScroll: handleScroll,
      onSize: handleSize,
      children: items.map((item, index) => /*#__PURE__*/_jsx(FilmstripItem, {
        children: /*#__PURE__*/_jsx(Image, {
          src: getDynamicCropMediaURL(item.dataURI, '300', '160'),
          alt: item.name,
          width: "300",
          height: "160",
          borderRadius: "4px",
          onImageInteraction: () => handleMediaClick(item)
        })
      }, "".concat(item.dataURI, "-").concat(index)))
    })
  });
};